import { Asset } from "contentful";

export const assetUri = (asset: Asset<"WITHOUT_UNRESOLVABLE_LINKS", string>) =>
  asset.fields.file?.url.replace(/^\/\//, 'https://') ?? '';
